<div *ngIf="translation.ready" class="h-100 d-flex flex-column">
<router-outlet></router-outlet>
</div>

